import './styles.scoped.css'
import {Button, Typography} from '@mui/material'

export default () => {
    const login = () => (window.location.href = `${process.env.REACT_APP_API_BASE_URL}/auth/login`)

    return (
        <div className="container">
            <Typography variant="h4">Welcome to Careviah</Typography>
            <br />
            <Typography variant="body1">Please log in to access your healthcare management dashboard.</Typography>
            <br />
            <Button variant="contained" color="primary" fullWidth onClick={login}>
                Log In with Keycloak
            </Button>
        </div>
    )
}
